/**
 * Banner viewable impressions: counted once per page view after ≥50% of the banner
 * stayed on screen for 1s (IAB standard). Hidden slots (e.g. rails on narrow screens) never count.
 * Server: POST /banner/impression/{id} (Banners::impression).
 */
(function () {
    'use strict';

    if (!('IntersectionObserver' in window)) return;

    var SELECTOR = '[data-banner-id]';
    var VISIBLE_RATIO = 0.5;
    var VISIBLE_MS = 1000;

    var sentIds = new Set();
    var timers = new Map();

    function send(id) {
        if (sentIds.has(id)) return;
        sentIds.add(id);

        var url = '/banner/impression/' + encodeURIComponent(id);
        if (navigator.sendBeacon && navigator.sendBeacon(url)) return;
        fetch(url, { method: 'POST', keepalive: true, credentials: 'same-origin' }).catch(function () {});
    }

    function stopTimer(el) {
        clearTimeout(timers.get(el));
        timers.delete(el);
    }

    var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            var el = entry.target;
            var id = el.getAttribute('data-banner-id');

            if (!id || sentIds.has(id)) {
                stopTimer(el);
                observer.unobserve(el);
                return;
            }

            if (entry.intersectionRatio < VISIBLE_RATIO) {
                stopTimer(el);
                return;
            }

            if (timers.has(el)) return;
            timers.set(el, setTimeout(function () {
                timers.delete(el);
                observer.unobserve(el);
                send(id);
            }, VISIBLE_MS));
        });
    }, { threshold: [0, VISIBLE_RATIO] });

    function observeWithin(node) {
        if (node.nodeType !== 1) return;
        if (node.matches(SELECTOR)) observer.observe(node);
        node.querySelectorAll(SELECTOR).forEach(function (el) { observer.observe(el); });
    }

    function init() {
        observeWithin(document.body);

        // Inline catalog cards are injected after infinite-scroll / filter loads.
        new MutationObserver(function (mutations) {
            mutations.forEach(function (m) { m.addedNodes.forEach(observeWithin); });
        }).observe(document.body, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
